import * as React from "react";
import type { SVGProps } from "react";
const SvgWarningSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#warning-square_svg__a)">
      <path d="M18 22H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h12c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4M6 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z" />
      <path d="M12 15c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v7c0 .55-.45 1-1 1M12 18c-.13 0-.26-.02-.38-.08q-.18-.075-.33-.21c-.04-.05-.09-.1-.12-.15a.8.8 0 0 1-.09-.18.6.6 0 0 1-.06-.18c0-.07-.02-.14-.02-.2 0-.07 0-.13.02-.2q.015-.09.06-.18c.02-.06.05-.12.09-.17.03-.06.08-.11.12-.16q.15-.135.33-.21c.36-.16.81-.07 1.09.21.04.05.09.1.12.16.04.05.07.11.09.17q.045.09.06.18c.01.07.02.13.02.2 0 .06 0 .13-.02.2 0 .06-.03.12-.06.18q-.03.09-.09.18c-.03.05-.08.1-.12.15-.19.18-.45.29-.71.29" />
    </g>
    <defs>
      <clipPath id="warning-square_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWarningSquare;
